export default "__VITE_ASSET__BlWYuhjS__"